import {Component, Vue} from 'vue-property-decorator'
import user_module from '@/modules/user/index';
import Linkedin from '@/components/linkedin/index.vue'

@Component({  
  components: {
    Linkedin
  }
})
export default class Footer extends Vue {
  sites: any[] = [
    {name: 'FACEBOOK', url: 'https://www.facebook.com/RiXtrema/', icon: 'fab fa-facebook'},
    {name: 'TWITTER', url: 'https://twitter.com/RiXtrema', icon: 'fab fa-twitter'},
    {name: 'LINKEDIN', url: 'https://www.linkedin.com/company/rixtrema-inc./', icon: 'fab fa-linkedin-in'},
    {name: 'PINTEREST', url: 'https://www.pinterest.com/LarkspurRiXtrema/', icon: 'fab fa-pinterest'},
    {name: 'VIMEO', url: 'https://soundcloud.com/rixtrema/', icon: 'fab fa-vimeo-v'},
    {name: 'APPLEPODCASTS', url: 'https://podcasts.apple.com/us/podcast/rixtrema/id1466695263', icon: 'fa fa-podcast'}
  ]

  get token(){
    return user_module.token;
  }

  components:{
  }
  
}

